import {
    OptimizationResult,
    OptimizationTask
} from '@idea2app/ai-work-order-service';

import { TableModel } from './Base';
import userStore from './User';

export type TaskType = 'classification' | 'deduplication';

export class TaskResultModel<
    T extends OptimizationTask,
    R extends OptimizationResult<T>
> extends TableModel<R> {
    baseURI = '';
    client = userStore.client;

    constructor(
        public taskType: TaskType,
        public taskId: number
    ) {
        super();
        this.baseURI = `/task/${taskType}/${taskId}/result`;
    }
}
